import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
import posterv1 from "../../assets/Images/posterv1.png";
import posterv1process1 from "../../assets/Images/posterv1process1.png";
import posterv1process2 from "../../assets/Images/posterv1process2.png";
import catposter1 from "../../assets/Images/catposter.png";





const WorkPosters = () => {
    const navigate = useNavigate();

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Posters</h1>
                <p>This was the process of making poster's concept</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-posters">

                    <div className="content-work-posters-text">
                        <h1>Process of Making Poster for Presentation</h1>
                        <p>Our group did a small research to gather information what Octolume could do for this project</p>

                        <p>For this concept posters, my group and I try to share our Idea and combine them together.</p>
                        <p>Me, Tommy and Sem try to make the concept poster on figma, and we took each other ideas and combine them together</p>


                        <p>We come up with a few solutions, one of it was my idea of making a 3D posters</p>
                        <p></p>

                    </div>
                    
                    <div className="content-work-posters-image">
                        <img src={posterv1}></img>
                    </div>

                    
                    <div className="content-work-posters-image2">
                        <br></br>
                        <img src={posterv1process1}></img>
                        <br></br>
                        <br></br>
                        <img src={posterv1process2}></img>
                        
                        

                    </div>

                    
                    <div className="content-work-posters-text2">
                        <h2>
                            Figma Process
                        </h2>
                        <p>As you can see on the right we went through steps on making our poster for the presentation. Why did narrow it to the poster that sem and tommy made, Personally I ask a few people to give a feedback and most of them like the red and white poster that sem made, but we were also given feedback from our teachers that we need to make it catchy for the poster.</p>
                        <p>So I ended up giving suggestion to Tommy that we should combine his work and Sem's work, although I was also doing my part in making the slogan (VISIBLE, EXCITING, DESIREABLE). I also made the poster in the middle during first and second iteration</p>

                    </div>

                    <div className="content-work-posters-text3">
                        <h2>Cat Posters</h2>
                        <p>Because our theme is cat meme, I tried to make a poster that connects meme of a cat and virtual production.
                            I used the background of Pixel Playground and I put cat behind the camera to give a funny message.
                        </p>
                        <p>
                            The Idea of making this poster is that I want to use this poster for field research and find out if our target 
                            audience will get attracted to this poster.
                        </p>
                        <h2>How do I check if people are attracted?</h2>
                        <p>I am planning to put this poster outside and put a qr code, with that I will be able to check how many people click/check
                            this poster out
                        </p>
                    </div>

                    <div className="content-work-posters-image3">
                        <img src={catposter1}></img>
                    </div>


                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkPosters;